module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-2-sp@2x_ca22dabe705689ad3b17f6e6a779ff2b.png";